'use client'

import { toProductPage } from '@/feature/product/services/product.routing'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useRouter } from '@/lib/navigation/PageNavigation.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'

export function BackTopProductPageLink({ url }: { url: string }) {
  const router = useRouter()
  const { t } = useTranslation(['productPage'])

  return (
    <Button
      size="md"
      variant="link"
      className="mt-2"
      iconLeft={<Icon.ArrowLeft size="sm" />}
      onPress={() => router.push(toProductPage(url))}
    >
      {t('productPage:backToProductPageLink.label')}
    </Button>
  )
}
